import { Routes, Route } from 'react-router-dom';
import Survey from '../views/Survey';
import SurveyError from '../views/SurveyError';

const RoutesMap = () => {
    const FreeRoute = ({ children }) => {
        return children;
    }

    return (
        <Routes>
            <Route
                path="/encuesta-satisfaccion"
                element={
                    <FreeRoute>
                        <Survey />
                    </FreeRoute>
                }
            />
            <Route
                path="/error"
                element={
                    <FreeRoute>
                        <SurveyError />
                    </FreeRoute>
                }
            />
            <Route
                path="*"
                element={<p>No se encontro la pagina: 404!</p>}
            />
        </Routes>
    );
}

export default RoutesMap;
